module.exports = {
  // Name of your site. Can be the name of a brand, or your personal name.
  title: 'LookUp India',
  // What's the purpose of this website? What can we expect from it?
  description: `An alternative to Linkinbio, built using Gatsby`,
  // Your legal name.
  legalName: 'LookUp India',
  // URL to this website. If you bought `www.domain.com`, then it will be `www.domain.com`.
  url: 'https://lookup.live',
  // Favicon that will display on browsers.
  logo: 'static/images/favicon.png',
  // Who made this website?
  author: 'LookUp Tech',
  // What's the website of the author?
  authorUrl: 'https://lookup.live',
  // Your social media presence, in the form of usernames.
  social: {
    // tells the Instagram API the username to get posts from.
    // If the url is `https://www.instagram.com/natgeotravel`, your username is `natgeotravel`.
    instagram: 'lookup.india',
    // Optional
    twitter: '@lookup_india',
  },
  socialLinks: {
    // Complete URL verison of `social.instagram`.
    instagram: 'https://www.instagram.com/lookup.india',
    // Optional
    twitter: 'https://twitter.com/lookup_india',
  },
  // If applicable, your Google Analytics crawl ID.
  googleAnalyticsId: 'UA-XXXXXXXX-X',
  // Colours that represent your website.
  themeColor: '#000',
  backgroundColor: '#121212',
  // No more information than City + Country due to privacy concerns.
  address: {
    country: 'India',
  },
  // Basic contact details.
  contact: {
    // Email address to contact you.
    email: 'lookupindia3@gmail.com',
  },
  // When was this website created?
  foundingDate: '2019',
};
